module.exports = __webpack_public_path__ + "media/18-5.7ed23a4f.mp4";